<template>
  <el-dialog
    :title="nameTitle"
    :visible.sync="dialogVisible"
    width="1000px"
    top="5vh"
    :before-close="handleClose"
    custom-class="watch-acc-dialog"
    append-to-body>
    
    <!-- 对话框内容 -->
    <div class="dialog-content">
      <!-- 基本信息区域 -->
      <div class="section">
        <div class="section-header">
          <span class="section-title">基本信息</span>
        </div>
        
        <!-- 员工信息表格 -->
        <div class="table-section">
          <div class="table-title">员工信息</div>
          <table class="info-table">
            <tbody>
              <tr>
                <td class="label">姓名：</td>
                <td class="value">
                  <el-input v-model="employeeData.fullName" placeholder="请输入姓名" size="mini" :disabled="true"></el-input>
                </td>
                <td class="label" :disabled="true">工号：</td>
				<td class="value">{{ employeeData.userCode || nextUserCode }}</td>
				<td class="label">性别：</td>
				<td class="value">
				  <el-select 
					v-model="employeeData.sex" 
					placeholder="请先输入身份证号" 
					size="mini"
					:disabled="true"
					class="disabled-select">
					<el-option label="男" value="1"></el-option>
					<el-option label="女" value="2"></el-option>
				  </el-select>
				<!--  <el-tooltip 
					v-if="!employeeData.idNumber" 
					content="请输入身份证号后自动判断性别" 
					placement="top">
					<i class="el-icon-info" style="color: #909399; margin-left: 5px;"></i>
				  </el-tooltip> -->
				</td>
				<td class="label">机构：</td>
				<td class="value">{{ currentClinicName }}</td>
			  </tr>
              <tr>
                <td class="label">部门：</td>
                <td class="value">
                  <el-select v-model="employeeData.deptName" placeholder="请选择部门" size="mini" filterable :disabled="true">
                    <el-option 
                      v-for="item in deptOptionsBM" 
                      :key="item.id" 
                      :label="item.label" 
                      :value="item.id">
                    </el-option>
                  </el-select>
                </td>
                <td class="label">岗位：</td>
                <td class="value">
                  <el-select v-model="employeeData.position" placeholder="请选择岗位" size="mini" filterable :disabled="true">
                    <el-option 
                      v-for="item in positionOptions" 
                      :key="item.id" 
                      :label="item.label" 
                      :value="item.label">
                    </el-option>
                  </el-select>
                </td>
                <td class="label">身份证：</td>
                <td class="value" colspan="3">
                  <el-input v-model="employeeData.idNumber" placeholder="请输入身份证号" size="mini" 
				   @blur="handleIdNumberBlur" :disabled="true"></el-input>
                </td>
                
              </tr>
              <tr>
				<td class="label">电话：</td>
				<td class="value">
				    <el-input v-model="employeeData.contactNumber" placeholder="请输入电话号码" size="mini" :disabled="true"></el-input>
				</td>
                <td class="label">出生年月：</td>
                <td class="value">
                  <el-date-picker
                    v-model="employeeData.birthDate"
                    type="date"
                    placeholder="选择日期"
                    size="mini"
                    value-format="yyyy-MM-dd"
					:disabled="true"
                    :picker-options="birthdayPickerOptions">
                  </el-date-picker>
                </td>
                <td class="label">农历生日：</td>
                <td class="value">
                  <el-input v-model="employeeData.lunarBirthDate" placeholder="自动计算" size="mini" :disabled="true"></el-input>
                </td>
                <td class="label">婚姻状况：</td>
                <td class="value">
                  <el-select v-model="employeeData.maritalStatus" placeholder="请选择婚姻状况" size="mini" :disabled="true">
                    <el-option 
                      v-for="item in marryiedOptions" 
                      :key="item.id" 
                      :label="item.label" 
                      :value="item.id">
                    </el-option>
                  </el-select>
                </td>
                
              </tr>
              <tr>
				<td class="label">政治面貌：</td>
				<td class="value">
				  <el-select v-model="employeeData.politicalStatus" placeholder="请选择政治面貌" size="mini" :disabled="true">
				    <el-option 
				      v-for="item in politicalStatusOptions" 
				      :key="item.id" 
				      :label="item.label" 
				      :value="item.id">
				    </el-option>
				  </el-select>
				</td>
                <td class="label">学历：</td>
                <td class="value">
                  <el-select v-model="employeeData.education" placeholder="请选择学历" size="mini" :disabled="true">
                    <el-option 
                      v-for="item in xlOptions" 
                      :key="item.id" 
                      :label="item.label" 
                      :value="item.id">
                    </el-option>
                  </el-select>
                </td>
                <td class="label">专业：</td>
                <td class="value">
                  <el-select v-model="employeeData.major" placeholder="请选择专业" size="mini" filterable :disabled="true">
                    <el-option 
                      v-for="item in mjOptions" 
                      :key="item.id" 
                      :label="item.label" 
                      :value="item.id">
                    </el-option>
                  </el-select>
                </td>
                <td class="label">毕业时间：</td>
                <td class="value">
                  <el-date-picker
                    v-model="employeeData.graduationDate"
                    type="date"
                    placeholder="选择日期"
                    size="mini"
					:disabled="true"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </td>
                
              </tr>
              <tr>
				<td class="label">专业职称：</td>
				<td class="value">
				  <el-select v-model="employeeData.professionalTitle" placeholder="请选择专业职称" size="mini" filterable>
				    <el-option 
				      v-for="item in professionalOptions" 
				      :key="item.id" 
				      :label="item.label" 
					  :disabled="true"
				      :value="item.id">
				    </el-option>
				  </el-select>
				</td>
                <td class="label">社保状态：</td>
                <td class="value">{{ employeeData.socialSecurityStatus || '是' }}</td>
                <td class="label">籍贯：</td>
                <td class="value" colspan="5">
                  <el-cascader
                    v-model="employeeData.nativePlace"
                    :options="nativeOptions"
                    :props="cascaderProps"
                    placeholder="请选择籍贯"
                    size="mini"
                    clearable
                    filterable
                    style="width: 100%"
					:disabled="true"
                    @change="handleNativePlaceChange">
                  </el-cascader>
                </td>
              </tr>
			  <tr>
				<td class="label">国籍：</td>
				<td class="value">
				  <el-select v-model="employeeData.nationality" placeholder="请选择国籍" size="mini" filterable :disabled="true">
					<el-option 
					  v-for="item in nationality" 
					  :key="item.id" 
					  :label="item.label" 
					  :value="item.id">
					</el-option>
				  </el-select>
				</td>
			    <td class="label">民族：</td>
			    <td class="value">
			      <el-select v-model="employeeData.minZu" placeholder="请选择国籍" size="mini" filterable :disabled="true">
			    	<el-option 
			    	  v-for="item in MZOptions" 
			    	  :key="item.id" 
			    	  :label="item.label" 
			    	  :value="item.id">
			    	</el-option>
			      </el-select>
			    </td>
			    <td class="label">血型：</td>
				<td class="value">
				  <el-select v-model="employeeData.bloodType" placeholder="请选择国籍" size="mini" filterable :disabled="true">
					<el-option 
					  v-for="item in bloodOptions" 
					  :key="item.id" 
					  :label="item.label" 
					  :value="item.id">
					</el-option>
				  </el-select>
				</td>
				<td class="label">证件类型：</td>
				<td class="value">
				  <el-select v-model="employeeData.idType" placeholder="请选择国籍" size="mini" filterable :disabled="true">
					<el-option 
					  v-for="item in idType" 
					  :key="item.id" 
					  :label="item.label" 
					  :value="item.id">
					</el-option>
				  </el-select>
				</td>
			  </tr>
            </tbody>
          </table>
        </div>
      </div>
      
	  <!-- 拥有权限区域 -->
		<div class="section">
		  <div class="section-header">
			<span class="section-title">拥有权限</span>
		  </div>
		  <div class="table-section">
			<div class="table-title">权限信息</div>
			<div class="permissions-container">
			  <!-- 修复权限复选框绑定 -->
			  <div class="permission-row">
				<el-checkbox :disabled="true" border size="medium" v-model="employeeData.prescriptionRights" :true-label="1" :false-label="0">处方权</el-checkbox>
				<el-checkbox :disabled="true" border size="medium" v-model="employeeData.chPrescriptionRights" :true-label="1" :false-label="0">中药处方权</el-checkbox>
			  </div>
			  <div class="permission-row">
				<el-checkbox :disabled="true" border size="medium" v-model="employeeData.anesthesiaAuthorization" :true-label="1" :false-label="0">麻药权限</el-checkbox>
				<el-checkbox :disabled="true" border size="medium" v-model="employeeData.surgicalPermission" :true-label="1" :false-label="0">手术权限</el-checkbox>
				<el-checkbox :disabled="true" border size="medium" v-model="employeeData.spiritPermission" :true-label="1" :false-label="0">精神权限</el-checkbox>
				<el-checkbox :disabled="true" border size="medium" v-model="employeeData.poisonPermission" :true-label="1" :false-label="0">毒药权限</el-checkbox>
				<el-checkbox :disabled="true" border size="medium" v-model="employeeData.antiTumorPermission" :true-label="1" :false-label="0">抗肿瘤药物权限</el-checkbox>
			  </div>
			</div>
		  </div>
		</div>
		
      <!-- 隶属科室区域 -->
	  <div class="section">
	      <div class="section-header">
	        <span class="section-title">隶属科室</span>
	      </div>
	      <div class="table-section">
	        <div class="header">
	          <div>科室信息</div>
	          <div>
	            <el-button
	              v-for="(v,i) in headerBtn" 
	              :key="i" 
	              :type="v.type" 
	              :icon="v.icon" 
	              size="mini"
	              :disabled="true"
	              @click="handleHeaderBtnClick(v, i)"
	            >
	              {{ v.title }}
	            </el-button>
	          </div>
	        </div>
	        
	        <el-table 
	          :data="tableData" 
	          border
	          @row-click="handleRowClick"
	          :row-class-name="tableRowClassName"
	          style="width: 100%"
			  :disabled="true"
	        >
	          <el-table-column 
	            v-for="(col, inx) in tableRows" 
	            :key="inx" 
	            :type="col.type" 
	            :prop="col.prop" 
	            :label="col.name">
	            <template slot-scope="scope">
	              <!-- 修复1: 主要科室显示为是/否 -->
	              <span v-if="col.prop === 'mainDep'">
	                {{ scope.row.mainDep === 1 ? '是' : '否' }}
	              </span>
	              <span v-else>
	                {{ scope.row[col.prop] }}
	              </span>
	            </template>
	          </el-table-column>
	          <el-table-column fixed="left" label="行号" type="index" width="50"></el-table-column>
	        </el-table>
	      </div>
	    </div>
      
      <!-- 证件信息区域 -->
		<div class="section">
		  <div class="table-section">
			<div class="table-title">证件信息</div>
			<table class="info-table">
			  <tbody>
				<tr>
				  <td class="label">证件名称：</td>
				  <td class="value">
					<el-input v-model="employeeData.certificateName" placeholder="请输入证件名称" size="mini" ssss:disabled="true"></el-input>
				  </td>
				  <td class="label">执业证号：</td>
				  <td class="value">
					<el-input v-model="employeeData.practicingNumber" placeholder="请输入执业证号" size="mini" ssss:disabled="true"></el-input>
				  </td>
				  <td class="label">所学专业：</td>
				  <td class="value">
					<el-select v-model="employeeData.major" placeholder="请选择专业" size="mini" filterable :disabled="true">
					  <el-option 
						v-for="item in mjOptions" 
						:key="item.id" 
						:label="item.label" 
						:value="item.id">
					  </el-option>
					</el-select>
				  </td>
				  <td class="label">资格证书编号：</td>
				  <td class="value">
					<el-input v-model="employeeData.qualificationNumber" placeholder="请输入资格证书编号" size="mini" :disabled="true"></el-input>
				  </td>
				</tr>
				<tr>
				  <td class="label">职业日期：</td>
				  <td class="value">
					<el-date-picker
					  v-model="employeeData.practiceDate"
					  type="date"
					  placeholder="选择日期"
					  size="mini"
					  :disabled="true"
					  value-format="yyyy-MM-dd">
					</el-date-picker>
				  </td>
				  <td class="label">生效时间：</td>
				  <td class="value">
					<el-date-picker
					  v-model="employeeData.effectiveDate"
					  type="date"
					  placeholder="选择日期"
					  size="mini"
					  :disabled="true"
					  value-format="yyyy-MM-dd">
					</el-date-picker>
				  </td>
				  <td class="label">有无期限：</td>
				  <td class="value">
					<el-select v-model="employeeData.hasTerm" placeholder="请选择" size="mini" :disabled="true">
					  <el-option label="有" value="1"></el-option>
					  <el-option label="无" value="0"></el-option>
					</el-select>
				  </td>
				  <td class="label">证书状态：</td>
				  <td class="value">
					<el-select v-model="employeeData.certificateStatus" placeholder="请选择状态" size="mini" :disabled="true">
					  <el-option label="有效" value="valid"></el-option>
					  <el-option label="无效" value="invalid"></el-option>
					  <el-option label="过期" value="expired"></el-option>
					</el-select>
				  </td>
				</tr>
				<tr>
				  <td class="label">证书去向：</td>
				  <td class="value">
					<el-select v-model="employeeData.certificateDirection" placeholder="请选择去向" size="mini" :disabled="true">
					  <el-option label="转入" value="transfer_in"></el-option>
					  <el-option label="转出" value="transfer_out"></el-option>
					  <el-option label="存档" value="archived"></el-option>
					</el-select>
				  </td>
				  <td class="label">存放地点：</td>
				  <td class="value">
					<el-input v-model="employeeData.storageLocation" placeholder="请输入存放地点" size="mini" :disabled="true"></el-input>
				  </td>
				  <td class="label">医保名称：</td>
				  <td class="value">
				  	<el-input v-model="employeeData.standardCode" placeholder="请输入医保名称" size="mini" :disabled="true"></el-input>
				  </td>
				   
				  <td class="label">医保编码：</td>
				  <td class="value">
				  	<el-input v-model="employeeData.standardName" placeholder="请输入医保编码" size="mini" :disabled="true"></el-input>
				  </td>
				   
				</tr>
				<tr>
				  <td class="label">备注：</td>
				  <td class="value" colspan="7">
					<el-input
					  type="textarea"
					  v-model="employeeData.certificateRemark"
					  placeholder="请输入备注信息"
					  size="mini"
					  :disabled="true"
					  :rows="2">
					</el-input>
				  </td>
				</tr>
			  </tbody>
			</table>
		  </div>
		</div>
    
      <!-- 其他文件区域 -->
		<div class="section">
		  <div class="table-section">
			<div class="table-title">其他文件</div>
			<table class="file-table">
			  <thead>
				<tr>
				  <th>手工签名</th>
				  <th>员工证件照</th>
				  <th>资格证电子图片</th>
				  <th>执业证电子图片</th>
				  <th>上传人</th>
				  <th>上传时间</th>
				  <th>操作</th>
				</tr>
			  </thead>
			  <tbody>
				<tr>
				  <td>
					<div class="file-upload-cell">
					  <span v-if="!employeeData.signatureImage">未上传</span>
					  <span v-else>{{ getFileName(employeeData.signatureImage) }}</span>
					  <el-button 
						type="text" 
						icon="el-icon-plus" 
						size="mini"
						:disabled="true"
						@click="openUploadDialog('signature')">
					  </el-button>
					</div>
				  </td>
				  <td>
					<div class="file-upload-cell">
					  <span v-if="!employeeData.workIdPhoto">未上传</span>
					  <span v-else>{{ getFileName(employeeData.workIdPhoto) }}</span>
					  <el-button 
						type="text" 
						icon="el-icon-plus" 
						size="mini"
						:disabled="true"
						@click="openUploadDialog('workPhoto')">
					  </el-button>
					</div>
				  </td>
				  <td>
					<div class="file-upload-cell">
					  <span v-if="!employeeData.qcElectronicImage">未上传</span>
					  <span v-else>{{ getFileName(employeeData.qcElectronicImage) }}</span>
					  <el-button 
						type="text" 
						icon="el-icon-plus" 
						size="mini"
						:disabled="true"
						@click="openUploadDialog('qualification')">
					  </el-button>
					</div>
				  </td>
				  <td>
					<div class="file-upload-cell">
					  <span v-if="!employeeData.pcElectronicImage">未上传</span>
					  <span v-else>{{ getFileName(employeeData.pcElectronicImage) }}</span>
					  <el-button 
						type="text" 
						icon="el-icon-plus" 
						size="mini"
						:disabled="true"
						@click="openUploadDialog('practice')">
					  </el-button>
					</div>
				  </td>
				  <td>{{ uploadUser }}</td>
				  <td>{{ uploadTime }}</td>
				  <td>
					<div class="action-buttons">
					  <el-button 
						type="text" 
						size="mini" 
						@click="viewFile(employeeData.signatureImage)"
						:disabled="true">
						查看
					  </el-button>
					  <el-button 
						type="text" 
						size="mini" 
						@click="downloadFile(employeeData.signatureImage)"
						:disabled="true">
						下载
					  </el-button>
					</div>
				  </td>
				</tr>
			  </tbody>
			</table>
		  </div>
		</div>
	  
		<!-- 扫描附件区域 -->
		<div class="section">
		  <div class="table-section">
			<div class="table-title">扫描附件</div>
			<table class="file-table">
			  <thead>
				<tr>
				  <th>文件名称</th>
				  <th>上传人</th>
				  <th>上传时间</th>
				  <th>操作</th>
				</tr>
			  </thead>
			  <tbody>
				<tr>
				  <td colspan="4" class="no-data">暂无扫描附件</td>
				</tr>
			  </tbody>
			</table>
		  </div>
		</div>
	  </div>
  
	  <!-- 上传模态框 -->
	  <el-dialog
		:title="uploadDialogTitle"
		:visible.sync="uploadDialogVisible"
		width="500px"
		:disabled="true"
		:before-close="handleUploadClose">
		
		<!-- 手工签名画板 -->
		<div v-if="currentUploadType === 'signature'" class="signature-pad-container">
		  <canvas 
			ref="signaturePad" 
			width="450" 
			height="200"
			style="border: 1px solid #ddd; background: #fff;">
		  </canvas>
		  <div class="signature-actions">
			<el-button size="mini" @click="clearSignature">清空</el-button>
			<el-button size="mini" @click="saveSignature">保存</el-button>
		  </div>
		</div>
		
		<!-- 图片上传 -->
		<div v-else class="image-upload-container">
		  <el-upload
			class="upload-demo"
			drag
			:action="uploadUrl"
			:headers="uploadHeaders"
			:on-success="handleUploadSuccess"
			:before-upload="beforeUpload"
			:show-file-list="false">
			<i class="el-icon-upload"></i>
			<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
			<div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过10MB</div>
		  </el-upload>
		</div>
		
		<span slot="footer" class="dialog-footer">
		  <el-button @click="handleUploadClose">取消</el-button>
		  <el-button 
			type="primary" 
			@click="confirmUpload"
			:disabled="!uploadedFile && currentUploadType !== 'signature'">
			确认
		  </el-button>
		</span>
	  </el-dialog>
	  
	<!-- 新增科室对话框 -->
	<el-dialog
	  :title="deptDialogTitle"
	  :visible.sync="deptDialogVisible"
	  width="400px"
	  :before-close="handleDeptDialogClose">
	  
	  <el-form :model="currentDept" label-width="80px">
		<el-form-item label="科室名称">
		  <el-select
			v-model="currentDept.deptName"
			placeholder="请选择科室"
			filterable
			style="width: 100%"
			@change="handleDeptChange"
		  >
			<el-option
			  v-for="item in deptOptions"
			  :key="item.id"
			  :label="item.label"
			  :value="item.label"
			  :disabled="isDeptSelected(item.label)"
			>
			  <span>{{ item.label }}</span>
			  <span style="float: right; color: #8492a6; font-size: 12px">
				{{ item.specialtyName }}
			  </span>
			</el-option>
		  </el-select>
		</el-form-item>
		
		<el-form-item label="主要科室">
		  <el-radio-group v-model="currentDept.mainDep">
			<el-radio :label="1">是</el-radio>
			<el-radio :label="0">否</el-radio>
		  </el-radio-group>
		</el-form-item>
	  </el-form>
	  
	  <span slot="footer" class="dialog-footer">
		<el-button @click="deptDialogVisible = false">取消</el-button>
		<el-button type="primary" @click="saveDept">保存</el-button>
	  </span>
	  
	</el-dialog>

    <!-- 对话框底部 -->
    <!-- 修改底部按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button 
            v-if="isEditMode" 
            type="primary" 
            @click="handleUpdate" 
            size="mini"
            :loading="loading">
            保存
          </el-button>

          <!-- <el-button type="primary" @click="handlePrint" size="mini">打印</el-button> -->
          <el-button v-else  @click="handleClose" size="medium">关闭</el-button>
        </span>
	</el-dialog>
</template>

<script>
import { getLunar } from 'chinese-lunar-calendar'
import { docclinic } from "@/api/cinic/cinic.js";
import { findAttribute, getArea, getArea2, getArea3 ,addStaff } from "@/api/user.js";
import { dict } from "@/api/staff/staff.js";
// 导入修改相关API方法
import { getStaff, updateStaff } from "@/api/user.js";

export default {
  name: 'WatchAccList',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
	// 移除employeeData prop，改为通过方法传入ID
    // employeeData: {
    //   type: Object,
    //   default: () => ({})
    // },
	employeeId: { // 新增: 接收员工ID
	  type: [Number, String],
	  default: null
	},
    existingUsers: {
      type: Array,
      default: () => []
    }
  },
  
  computed: {
      uploadDialogTitle() {
        const titles = {
          signature: '上传手工签名',
          workPhoto: '上传员工证件照',
          qualification: '上传资格证电子图片',
          practice: '上传执业证电子图片'
        };
        return titles[this.currentUploadType] || '文件上传';
      },
	  // 添加计算属性，判断是否在编辑模式
	  isEditingMode() {
		return this.isEditMode || this.editingDeptIndex !== -1;
	  }
    },
  data() {
    return {
		deptList:[],
		deptOptions:[],
		deptOptionsBM:[],
		xlOptions:[],
		mjOptions:[],
		idType:[],
		dialogVisible: false,

		// 添加编辑模式标识
		isEditMode: false,
		// 存储员工ID
		currentEmployeeId: null,
		// 添加加载状态
		loading: false,
		// 存储原始ID用于更新
		originalId: null,
		// 修复：移除未定义的 currentAddEmployeeData，使用正确的数据属性
		currentEmployeeData: null,
		// 移除这行：currentAddEmployeeData: null,
		// 使用正确的数据属性
		// 添加employeeData到data中，不再从props获取
		employeeData: {},
		onUpdateSuccess: {
		      type: Function,
		      default: () => {}
		    },
		// 新增科室对话框相关
		deptDialogVisible: false,
		deptDialogTitle: '新增隶属科室',
		currentDept: {
		  deptName: '',
		  deptId: '',
		  mainDep: '否'
		},
		editingDeptIndex: -1, // 当前编辑的科室索引
      currentClinicName: '',
      nextUserCode: '001',
	  idNumberError: '', // 身份证错误提示
      // 表单选项数据
	  addForm:{
	  	status:'1',
	  	userCode: "", //编码
	  	// fullNane: "001",//姓名
	  	fullName: "",//姓名
	  	idType:1,//身份证类型id
	  	idTypeName:"",//身份证类型
	  	idNumber: "", //身份证号码
	  	sex: "",//性别
	  	dateOfEmp: "",//工作日期
	  	birthDate: "",//出生日期
	  	lunarBirthDate: "", //农历出生日期
	  	minZu:"", //民族
	  	nationality:1,//国籍
	  	// nativePlace:"",//籍贯
	  	maritalStatus:"", //婚姻状况 1:未婚 2:已婚 3:离异
	  	politicalStatus:"",//政治面貌
	  	bloodType:"",//血型
	  	contactNumber:'',//联系电话
	  	contactAddress:'',//联系地址
	  	entryTime:'2025-01-18',//入职时间
	  	institutionId:"",//隶属机构
	  	clinicId:'',// 当前诊所id
	  	contactAddress:'',//联系地址
	  	nativePlace:'',//户籍地址 = 籍贯
	  	standardCode:'',//医保编码
	  	standardName:'',//医保名称
	  	standardName:'',//医保名称
	  	//2
	  	deptList:[],
		deptOptions:[],
		deptOptionsBM:[],
		xlOptions:[],
		mjOptions:[],
		idType:[],
	  	educationalBackground:'',//学历
	  	major:'',//所学专业
	  	professionalTitle:'',//专业职称
	  	qualificationNumber:'',//资格证号
	  	practiceDate:'',//职业日期
	  	prescriptionRights:0,//处方权
	  	chPrescriptionRights:0,//中药处方权
	  	anesthesiaAuthorization:0,//麻药权限
	  	surgicalPermission:0,//手术权限
	  	spiritPermission:0,//精神权限
	  	poisonPermission:0,//毒药权限
	  	antiTumorPermission:0,//抗肿瘤药物权限
	  	antibioticAuthorization:0, // 抗生素等级
	  	roleId:[],
	  	//3
	  	signatureImage:'',//手工签名照片
	  	workIdPhoto:'',//工作证件照
	  	pcElectronicImage:'',//执业证电子图片
	  	qcElectronicImage:''//资格证电子图片
	  },
	
      positionOptions: [
        { id: 1, label: '项目经理' },
        { id: 2, label: '开发工程师' },
        { id: 3, label: '测试工程师' },
        { id: 4, label: 'UI设计师' }
      ],
      educationOptions: [
        { id: 1, label: '高中' },
        { id: 2, label: '大专' },
        { id: 3, label: '本科' },
        { id: 4, label: '硕士' },
        { id: 5, label: '博士' }
      ],
      majorOptions: [
        { id: 1, label: '计算机科学' },
        { id: 2, label: '软件工程' },
        { id: 3, label: '水利水电工程' },
        { id: 4, label: '电子信息工程' }
      ],
      professionalTitleOptions: [
        { id: 1, label: '初级' },
        { id: 2, label: '中级' },
        { id: 3, label: '高级' },
        { id: 4, label: '专家' }
      ],
      maritalStatusOptions: [],
      politicalStatusOptions: [
        { id: 0, label: '中共党员' },
        { id: 2, label: '中共预备党员' },
        { id: 3, label: '共青团员' },
        { id: 4, label: '民革党员' },
        { id: 5, label: '民盟盟员' },
        { id: 6, label: '民建会员' },
        { id: 7, label: '民进会员' },
        { id: 8, label: '农工党党员' },
        { id: 9, label: '致公党党员' },
        { id: 10, label: '九三学社社员' },
        { id: 11, label: '台盟盟员' },
        { id: 12, label: '无党派人士' },
        { id: 13, label: '群众' }
      ],
      // 籍贯地址相关
      nativeOptions: [],
      cascaderProps: {
        lazy: true,
        lazyLoad: this.loadAreaData
      },
	  nationality:[{id:1,label:'中国'}], //国籍
	  bloodOptions:[],  // 血型
	  marryiedOptions:[],  // 婚姻状况
	  professionalOptions:[], // 专业职称
	  MZOptions:[],
      // 生日日期选择器选项
      birthdayPickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      
	  // 权限相关 - 修复：移除selectedPermissions数组，直接绑定到employeeData
	   permissions: {
		 prescriptionRights: 0,
		 chPrescriptionRights: 0,
		 anesthesiaAuthorization: 0,
		 surgicalPermission: 0,
		 spiritPermission: 0,
		 poisonPermission: 0,
		 antiTumorPermission: 0
	   },
      
      // 其他原有数据保持不变
      tableData: [],
      tableRows: [
        { name: "科室名称", prop: "deptName", type: "" },
        { name: "主要科室", prop: "mainDep", type: "" }
      ],
      headerBtn: [
		  { 
			title: "新增", 
			type: "success", 
			icon: "el-icon-plus",
			action: 'add',
			disabled: false
		  },
		  { 
			title: "编辑", 
			type: "primary", 
			icon: "el-icon-edit",
			action: 'edit',
			disabled: false
		  }, 
		  { 
			title: "删除", 
			type: "danger", 
			icon: "el-icon-delete",
			action: 'delete',
			disabled: false
		  }
		],
      selectedRow: null,
      editingRow: null,
      
      // 表单验证规则
      rules: {
        fullName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idNumber: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, 
            message: '请输入正确的身份证号码', trigger: 'blur' }
        ],
        contactNumber: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/, 
            message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      },
      
      // 新增隶属科室模态框相关数据
      ksDialog: false,
      nameTitle: '新建员工',
      addBtn: true,
      addKsForm: {
        deptName: '',
        deptId: '',
        mainDep: '是',
      },
      formKsType: [
        { id:0, label:'隶属科室：',spanRows:24,type:'select',modelValue:'deptName',prefix:'el-icon-require',im:true,placeholder:'',op:'deptOption' },
        { id:1, label:'主要科室：',spanRows:24,type:'select',modelValue:'mainDep',prefix:'el-icon-require',im:false,placeholder:'',op:'statusOptions' },
      ],
	  // 上传相关数据
		uploadDialogVisible: false,
		currentUploadType: '',
		uploadedFile: null,
		signatureImage: null,
		uploadUrl: 'http://192.168.101.20:9999/outpatient/builderImage',
		uploadHeaders: {
		  'Authentication': localStorage.getItem('token')
		},
		uploadUser: 'admin',
		uploadTime: new Date().toLocaleString(),
      statusOptions: [{id:1,label:'是',value:'重要科室'},{id:0,label:'否',value:'重要科室'}],
      deptOption: [],
      clinicId: '',
      clincOptions: []
    };
  },
  watch: {
	// 监听选择行变化，更新按钮状态
	selectedRow(newVal) {
	  this.updateButtonStates();
	},
	// 监听编辑模式变化，更新按钮状态
	isEditMode(newVal) {
	  this.updateButtonStates();
	},
    visible: {
      immediate: true,
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.initData();
        }
      }
    },
    dialogVisible: {
      handler(newVal) {
        this.$emit('update:visible', newVal);
      }
    },
    employeeData: {
      immediate: true,
      handler(newData) {
        if (newData && newData.deptList) {
          this.tableData = newData.deptList;
        }
      }
    },
    'employeeData.idNumber': {
      handler(newVal) {
        if (newVal && newVal.length === 18) {
          this.calculateInfoFromIdNumber(newVal);
        }
      }
    }
  },
  mounted() {
    this.initData();
	
  },
  methods: {
    // 初始化数据
    async initData() {
      await this.getCurrentClinic();
      await this.calculateNextUserCode();
      await this.loadDictData();
      this.getInstitutionId();
      this.loadDeptOptions();
	  this.loadDeptOptionsBM();
      this.loadAreaProvince();
    },
	
    // 获取当前诊所信息
    async getCurrentClinic() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (userInfo && userInfo.clinicName) {
          this.currentClinicName = userInfo.clinicName;
          this.employeeData.organization = userInfo.clinicName;
        } else {
          // 如果没有存储的诊所信息，尝试从API获取
          const res = await docclinic();
          if (res.code === 200 && res.data.length > 0) {
            this.currentClinicName = res.data[0].name;
            this.employeeData.organization = res.data[0].name;
          }
        }
      } catch (error) {
        console.error('获取诊所信息失败:', error);
        this.currentClinicName = '默认机构';
        this.employeeData.organization = '默认机构';
      }
    },
    
	// 打开编辑模式 - 修改后的方法
	async openEditModel(employeeId) {
	  this.isEditMode = true;
	  this.nameTitle = '修改员工';
	  this.currentEmployeeId = employeeId;
	  
	  console.log('开始获取员工数据，ID:', this.currentEmployeeId);
	  
	  try {
		this.loading = true;
		this.originalId = this.currentEmployeeId;
		// 调用接口获取员工数据
		const res = await getStaff({ id: this.currentEmployeeId });
		console.log('API响应:', res);
		
		if (res && res.code === 200) {
		  console.log('获取到的员工数据:', res.data);
		  console.log('原始sex值:', res.data.sex, '类型:', typeof res.data.sex);
		  
		  // 处理sex字段转换 - 先处理sex字段，避免被身份证逻辑覆盖
		  const processedData = this.processEmployeeData(res.data);
		  console.log('处理后的数据:', processedData);
		  console.log('处理后的sex值:', processedData.sex);
		  
		  // 使用深拷贝赋值
		  this.employeeData = JSON.parse(JSON.stringify(processedData));
		  console.log('赋值后的employeeData:', this.employeeData);
		  console.log('赋值后的sex值:', this.employeeData.sex);
		  
		  // 处理部门列表数据
		  if (res.data.deptList && Array.isArray(res.data.deptList)) {
			this.tableData = res.data.deptList.map(dept => ({
			  ...dept,
			  mainDep: dept.mainDep === 1 ? '是' : '否'
			}));
		  }
		  
		  // 打开对话框
		  this.dialogVisible = true;
		} else {
		  console.error('API返回错误:', res);
		  this.$message.error(res?.message || '获取员工数据失败');
		}
	  } catch (error) {
		console.error('获取员工数据失败:', error);
		this.$message.error('获取员工数据失败: ' + error.message);
	  } finally {
		this.loading = false;
	  }
	},
	
	// 打开查看模式 - 修改后的方法
	async openWatchModel(employeeId) {
	  this.isEditMode = false;
	  this.nameTitle = '查看员工';
	  this.currentEmployeeId = employeeId;
	  
	  // console.log('开始获取员工数据，ID:', this.currentEmployeeId);
	  
	  try {
		this.loading = true;
		this.originalId = this.currentEmployeeId;
		// 调用接口获取员工数据
		const res = await getStaff({ id: this.currentEmployeeId });
		// console.log('API响应:', res);
		
		if (res && res.code === 200) {
		  // console.log('获取到的员工数据:', res.data);
		  // console.log('原始sex值:', res.data.sex, '类型:', typeof res.data.sex);
		  
		  // 处理sex字段转换 - 先处理sex字段，避免被身份证逻辑覆盖
		  const processedData = this.processEmployeeData(res.data);
		  // console.log('处理后的数据:', processedData);
		  // console.log('处理后的sex值:', processedData.sex);
		  
		  // 使用深拷贝赋值
		  this.employeeData = JSON.parse(JSON.stringify(processedData));
		  // console.log('赋值后的employeeData:', this.employeeData);
		  // console.log('赋值后的sex值:', this.employeeData.sex);
		  
		  // 处理部门列表数据
		  if (res.data.deptList && Array.isArray(res.data.deptList)) {
			this.tableData = res.data.deptList.map(dept => ({
			  ...dept,
			  mainDep: dept.mainDep === 1 ? '是' : '否'
			}));
		  }
		  
		  // 打开对话框
		  this.dialogVisible = true;
		} else {
		  console.error('API返回错误:', res);
		  this.$message.error(res?.message || '获取员工数据失败');
		}
	  } catch (error) {
		console.error('获取员工数据失败:', error);
		this.$message.error('获取员工数据失败: ' + error.message);
	  } finally {
		this.loading = false;
	  }
	},
	
	// 处理员工数据，转换sex字段 - 修复方法
	processEmployeeData(data) {
	  if (!data) {
		console.warn('processEmployeeData: 数据为空');
		return {};
	  }
	  
	  console.log('原始数据:', data);
	  
	  try {
		// 深拷贝数据
		const processed = JSON.parse(JSON.stringify(data));
		
		// 转换sex字段：int -> string - 修复逻辑
		if (processed.sex !== undefined && processed.sex !== null) {
		  console.log('原始sex值:', processed.sex, '类型:', typeof processed.sex);
		  
		  // 保存原始sex值用于比较
		  const originalSex = processed.sex;
		  
		  if (typeof processed.sex === 'number') {
			// 1 -> '1' (男), 2 -> '2' (女) - 直接转换，不进行其他逻辑
			processed.sex = processed.sex.toString();
			console.log('数字转换:', originalSex, '->', processed.sex);
		  } else if (typeof processed.sex === 'string') {
			// 确保字符串格式正确
			if (processed.sex === '1' || processed.sex === '2') {
			  // 已经是正确格式，不做处理
			  console.log('字符串已是正确格式:', processed.sex);
			} else if (processed.sex === '男' || processed.sex.toLowerCase() === 'male') {
			  processed.sex = '1';
			  console.log('转换"男"为"1"');
			} else if (processed.sex === '女' || processed.sex.toLowerCase() === 'female') {
			  processed.sex = '2';
			  console.log('转换"女"为"2"');
			} else {
			  console.warn('未知的sex值:', processed.sex);
			  // 保持原值，不进行转换
			}
		  }
		}
		
		console.log('处理后的数据:', processed);
		return processed;
		
	  } catch (error) {
		console.error('数据处理错误:', error);
		return data; // 返回原始数据作为fallback
	  }
	},
	
	// 身份证号输入完成处理 
	handleIdNumberBlur() {
	  const idNumber = this.employeeData.idNumber;
	  
	  // 清空错误提示
	  this.idNumberError = '';
	  
	  if (!idNumber) {
		this.idNumberError = '请输入身份证号码';
		return;
	  }
	  
	  // 验证身份证格式
	  const idCardPattern = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20极速电竞官网|30|31)\d{3}[0-9Xx]$/;
	  if (!idCardPattern.test(idNumber)) {
		this.idNumberError = '请输入正确的18位身份证号码';
		return;
	  }
	  
	  // 计算相关信息
	  this.calculateInfoFromIdNumber(idNumber);
	},
	
	// 根据身份证号码计算相关信息 - 修复方法：不要强制覆盖sex
	calculateInfoFromIdNumber(idNumber) {
	  if (idNumber && idNumber.length === 18) {
		try {
		  // 提取出生日期
		  const year = idNumber.substr(6, 4);
		  const month = idNumber.substr(10, 2);
		  const day = idNumber.substr(12, 2);
		  
		  // 设置出生日期
		  this.employeeData.birthDate = `${year}-${month}-${day}`;
		  
		  // 计算农历生日
		  try {
			const lunarInfo = getLunar(parseInt(year), parseInt(month), parseInt(day));
			this.employeeData.lunarBirthDate = lunarInfo.dateStr;
		  } catch (error) {
			console.error('计算农历生日失败:', error);
			this.employeeData.lunarBirthDate = '计算失败';
		  }
		  
		  // 判断性别
		  const genderCode = parseInt(idNumber.substr(16, 1));
		  this.employeeData.sex = genderCode % 2 === 1 ? '1' : '2';
		  
		  this.$message.success('身份证信息已自动填充');
		  
		} catch (error) {
		  console.error('处理身份证信息失败:', error);
		  this.$message.error('处理身份证信息失败');
		}
	  }
	},

	// 处理保存更新
	async handleUpdate() {
	  try {
		// 表单验证
		if (!this.validateForm()) {
		  return;
		}
		
		// 检查科室信息
		if (!this.tableData || this.tableData.length === 0) {
		  this.$message.error('请至少添加一个隶属科室');
		  return;
		}
		
		this.loading = true;
		
		// 准备提交数据
		const submitData = {
		  ...this.employeeData,
		  id: this.originalId, // 保留原始ID
		  deptList: this.tableData.map(dept => ({
			deptId: dept.deptId,
			deptName: dept.deptName,
			mainDep: dept.mainDep === '是' ? 1 : 0
		  }))
		};
		
		// 调用更新API
		const res = await updateStaff(submitData);
		
		if (res.code === 200) {
		  this.$message.success(res.message || '更新成功');
		  // 通知父组件更新成功
		  this.$emit('update-success');
		  this.handleClose();
		} else {
		  this.$message.error(res.message || '更新失败');
		}
	  } catch (error) {
		console.error('更新失败:', error);
		this.$message.error('更新过程中发生错误');
	  } finally {
		this.loading = false;
	  }
	},
	
	// 处理新建保存（原有方法）
	async handleSave() {
	  try {
		// 表单验证
		if (!this.validateForm()) {
		  return;
		}
		
		// 检查科室信息
		if (!this.tableData || this.tableData.length === 0) {
		  this.$message.error('请至少添加一个隶属科室');
		  return;
		}
		
		this.loading = true;
		
		// 准备提交数据
		const submitData = {
		  ...this.addForm,
		  deptList: this.tableData.map(dept => ({
			deptId: dept.deptId,
			deptName: dept.deptName,
			mainDep: dept.mainDep === '是' ? 1 : 0
		  }))
		};
		
		// 调用新建API
		const res = await addStaff(submitData);
		
		if (res.code === 200) {
		  this.$message.success(res.message || '新建成功');
		  this.$emit('save-success'); // 触发新建成功事件
		  this.handleClose();
		} else {
		  this.$message.error(res.message || '新建失败');
		}
	  } catch (error) {
		console.error('新建失败:', error);
		this.$message.error('新建过程中发生错误');
	  } finally {
		this.loading = false;
	  }
	},
		
    // 计算下一个工号
    calculateNextUserCode() {
      if (this.existingUsers && this.existingUsers.length > 0) {
        // 获取最大的工号并加1
        const maxCode = Math.max(...this.existingUsers.map(user => {
          const code = parseInt(user.userCode || '0');
          return isNaN(code) ? 0 : code;
        }));
        console.log(maxCode,'maxCode');
        this.nextUserCode = (maxCode + 1).toString().padStart(3, '0');
      } else {
        this.nextUserCode = '';
      }
      this.employeeData.userCode = this.nextUserCode;
    },
    // 文件上传相关方法
        openUploadDialog(type) {
          this.currentUploadType = type;
          this.uploadDialogVisible = true;
          this.uploadedFile = null;
          this.signatureImage = null;
          
          // 如果是手工签名，初始化画板
          if (type === 'signature') {
            this.$nextTick(() => {
              this.initSignaturePad();
            });
          }
        },
        
        initSignaturePad() {
          const canvas = this.$refs.signaturePad;
          const ctx = canvas.getContext('2d');
          let isDrawing = false;
          let lastX = 0;
          let lastY = 0;
          
          // 设置画板样式
          ctx.strokeStyle = '#000';
          ctx.lineWidth = 2;
          ctx.lineCap = 'round';
          ctx.lineJoin = 'round';
          
          // 鼠标事件
          const startDrawing = (e) => {
            isDrawing = true;
            [lastX, lastY] = [e.offsetX, e.offsetY];
          };
          
          const draw = (e) => {
            if (!isDrawing) return;
            ctx.beginPath();
            ctx.moveTo(lastX, lastY);
            ctx.lineTo(e.offsetX, e.offsetY);
            ctx.stroke();
            [lastX, lastY] = [e.offsetX, e.offsetY];
          };
          
          const stopDrawing = () => {
            isDrawing = false;
          };
          
          // 添加事件监听
          canvas.addEventListener('mousedown', startDrawing);
          canvas.addEventListener('mousemove', draw);
          canvas.addEventListener('mouseup', stopDrawing);
          canvas.addEventListener('mouseout', stopDrawing);
          
          // 触摸事件支持
          canvas.addEventListener('touchstart', (e) => {
            e.preventDefault();
            const touch = e.touches[0];
            const mouseEvent = new MouseEvent('mousedown', {
              clientX: touch.clientX,
              clientY: touch.clientY
            });
            canvas.dispatchEvent(mouseEvent);
          });
          
          canvas.addEventListener('touchmove', (e) => {
            e.preventDefault();
            const touch = e.touches[0];
            const mouseEvent = new MouseEvent('mousemove', {
              clientX: touch.clientX,
              clientY: touch.clientY
            });
            canvas.dispatchEvent(mouseEvent);
          });
          
          canvas.addEventListener('touchend', () => {
            const mouseEvent = new MouseEvent('mouseup');
            canvas.dispatchEvent(mouseEvent);
          });
        },
        
        clearSignature() {
          const canvas = this.$refs.signaturePad;
          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        },
        
        saveSignature() {
          const canvas = this.$refs.signaturePad;
          this.signatureImage = canvas.toDataURL('image/png');
          this.$message.success('签名已保存');
        },
        
        handleUploadSuccess(response, file) {
          if (response.code === 200) {
            this.uploadedFile = response.data;
            this.$message.success('上传成功');
          } else {
            this.$message.error('上传失败');
          }
        },
        
        beforeUpload(file) {
          const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
          const isLt10M = file.size / 1024 / 1024 < 10;
          
          if (!isImage) {
            this.$message.error('只能上传JPG/PNG格式的图片!');
          }
          if (!isLt10M) {
            this.$message.error('图片大小不能超过10MB!');
          }
          
          return isImage && isLt10M;
        },
        
        confirmUpload() {
          if (this.currentUploadType === 'signature') {
            if (this.signatureImage) {
              // 将base64转换为文件并上传
              this.uploadSignatureImage();
            } else {
              this.$message.warning('请先绘制签名');
            }
          } else if (this.uploadedFile) {
            this.assignUploadedFile();
            this.uploadDialogVisible = false;
          }
        },
        
        async uploadSignatureImage() {
          try {
            // 将base64转换为blob
            const response = await fetch(this.signatureImage);
            const blob = await response.blob();
            const file = new File([blob], 'signature.png', { type: 'image/png' });
            
            const formData = new FormData();
            formData.append('file', file);
            
            const res = await axios.post(this.uploadUrl, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authentication': localStorage.getItem('token')
              }
            });
            
            if (res.data.code === 200) {
              this.uploadedFile = res.data.data;
              this.assignUploadedFile();
              this.uploadDialogVisible = false;
              this.$message.success('签名上传成功');
            }
          } catch (error) {
            console.error('签名上传失败:', error);
            this.$message.error('签名上传失败');
          }
        },
        
        assignUploadedFile() {
          const fieldMap = {
            signature: 'signatureImage',
            workPhoto: 'workIdPhoto',
            qualification: 'qcElectronicImage',
            practice: 'pcElectronicImage'
          };
          
          if (fieldMap[this.currentUploadType]) {
            this.employeeData[fieldMap[this.currentUploadType]] = this.uploadedFile;
            this.$emit('update:employeeData', this.employeeData);
          }
        },
        
        handleUploadClose() {
          this.uploadDialogVisible = false;
          this.uploadedFile = null;
          this.signatureImage = null;
        },
        
        getFileName(url) {
          if (!url) return '';
          return url.split('/').pop() || '已上传文件';
        },

	    // 保存员工信息
	    async saveEmployee() {
	      try {
	        // 验证表单
	        await this.$refs.addForm.validate();
	
	        // 检查是否有主要科室
	        const hasMainDept = this.addForm.deptList.some(dept => dept.mainDep === '是');
	        if (!hasMainDept) {
	          this.$message.error('必须设置一个主要科室');
	          return;
	        }
	
	        // 准备数据
	        const submitData = this.formatSubmitData();
	        
	        // 触发保存事件
	        this.$emit('save', submitData);
	        
	      } catch (error) {
	        console.error('表单验证失败:', error);
	      }
	    },
	
	    // 格式化提交数据
	    formatSubmitData() {
	      return {
	        ...this.addForm,
	        deptList: this.addForm.deptList.map(dept => ({
	          deptName: dept.deptName,
	          deptId: dept.deptId,
	          mainDep: dept.mainDep
	        }))
	      };
	    },
    // 加载字典数据
    async loadDictData() {
      try {
        const res = await dict();
        if (res.code === 200) {
		// 设置本地存储
		localStorage.setItem('dict', JSON.stringify(res.data));
        //  证件类型
        this.idType = res.data.certypeEntities.map(v=>{ return { label: v.name , ...v }});
        //  民族
        this.MZOptions = res.data.natyEntities.map(v=>{ return { label: v.name , ...v }})
        //  专业职称
        this.professionalOptions = res.data.profttlEntities.map(v=>{ return { label: v.name , ...v }})
        // 所学专业
        this.mjOptions = res.data.jobEntities.map(v=>{ return { label: v.name , ...v }})
        // 学历
        this.xlOptions = res.data.edulBacdEntities.map(v=>{ return { label: v.name , ...v }})
        // 婚姻状况选项
        this.marryiedOptions = res.data.mrgStateEntities.map(v=>{ return { label: v.name , ...v }})
        //  血型
        this.bloodOptions = res.data.aboTypeEntities.map(v=>{ return { label: v.name , ...v }})
        // 暂时过滤掉RH阴性和RH阳性的选项
        this.bloodOptions = this.bloodOptions.filter(item =>
          item.name !== 'RH阳性' && item.name !== 'RH阴性'
        );
        }
      } catch (error) {
        console.error('获取字典数据失败:', error);
        // 设置默认婚姻状况选项
        this.maritalStatusOptions = [
          { id: 1, label: '未婚' },
          { id: 2, label: '已婚' },
          { id: 3, label: '离异' },
          { id: 4, label: '丧偶' }
        ];
      }
    },
    

    
    // 权限变更处理
    handlePermissionChange(permissions) {
      const allPermissions = [
        'prescriptionRights', 'chPrescriptionRights', 'anesthesiaAuthorization',
        'surgicalPermission', 'spiritPermission', 'poisonPermission',
        'antiTumorPermission'
      ];
      
      allPermissions.forEach(permission => {
        this.employeeData[permission] = permissions.includes(permission) ? 1 : 0;
      });
    },
    
    // 关闭对话框
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    
    
    // 添加表单验证方法
    validateForm() {
      if (!this.employeeData.fullName?.trim()) {
        this.$message.error('请输入姓名');
        return false;
      }
    
      if (!this.employeeData.idNumber) {
        this.$message.error('请输入身份证号码');
        return false;
      }
    
      // 身份证格式验证
      const idCardPattern = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!idCardPattern.test(this.employeeData.idNumber)) {
        this.$message.error('请输入正确的身份证号码');
        return false;
      }
    
      if (!this.employeeData.contactNumber) {
        this.$message.error('请输入联系电话');
        return false;
      }
    
      // 手机号格式验证
      const phonePattern = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      if (!phonePattern.test(this.employeeData.contactNumber)) {
        this.$message.error('请输入正确的手机号码');
        return false;
      }
    
      return true;
    },

          
          // 加载部门选项
          async loadDeptOptionsBM() {
            try {
              // 这里可以根据实际情况调用API获取部门数据
              this.deptOptionsBM = [
                { id: 1, label: '项目部' },
                { id: 2, label: '技术部' },
                { id: 3, label: '人事部' },
                { id: 4, label: '财务部' }
              ];
            } catch (error) {
              console.error('获取部门选项失败:', error);
            }
          },
          
          // 加载省级数据
          async loadAreaProvince() {
            try {
              const res = await getArea();
              if (res.code === 200) {
                this.nativeOptions = res.data.map(item => ({
                  value: item.areaName,
                  label: item.areaName,
                  leaf: false
                }));
              }
            } catch (error) {
              console.error('获取省份数据失败:', error);
            }
          },
          
          // 级联选择懒加载方法
          async loadAreaData(node, resolve) {
            try {
              const { level } = node;
              let data = [];
              
              if (level === 0) {
                // 已加载过省级数据，直接返回
                resolve(this.nativeOptions);
                return;
              }
              
              if (level === 1) {
                // 加载市级数据
                const res = await getArea2({ areaLevel: 2, areaPName: node.value });
                if (res.code === 200) {
                  data = res.data.map(item => ({
                    value: item.areaName,
                    label: item.areaName,
                    leaf: level >= 2
                  }));
                }
              } else if (level === 2) {
                // 加载区级数据
                const parent = node.parent;
                const res = await getArea3({ 
                  areaLevel: 3, 
                  areaPName: parent.value, 
                  areaCName: node.value 
                });
                if (res.code === 200) {
                  data = res.data.map(item => ({
                    value: item.areaName,
                    label: item.areaName,
                    leaf: true
                  }));
                }
              }
              
              resolve(data);
            } catch (error) {
              console.error('加载地区数据失败:', error);
              resolve([]);
            }
          },
          
          // 籍贯选择变化处理
          handleNativePlaceChange(value) {
            console.log('选择的籍贯:', value);
            this.employeeData.nativePlace = value.join('/');
          },
          
          // 格式化日期
          formatDate(date) {
            if (!date) return '';
            return typeof date === 'string' ? date : date.toString();
          },
          
          // 查看文件
          viewFile(fileName) {
            this.$message.info(`查看文件: ${fileName}`);
          },
          
          // 下载文件
          downloadFile(fileName) {
            this.$message.success(`开始下载: ${fileName}`);
          },
          
          // 打印档案
          handlePrint() {
            this.$message.info('打印员工档案');
          },
          
          // 隶属科室相关方法
		  handleHeaderBtnClick(btn, index) {
		        if (btn.disabled) return;
		        
		        switch (btn.action) {
		          case 'add':
		            this.openAddDeptDialog();
		            break;
		          case 'edit':
		            if (this.selectedRow) {
		              this.openEditDeptDialog();
		            }
		            break;
		          case 'delete':
		            if (this.selectedRow) {
		              this.handleDeleteDept();
		            }
		            break;
		        }
		      },
		      
		      // 打开编辑科室对话框
		      openEditDeptDialog() {
				this.deptDialogTitle = '编辑隶属科室';
				this.currentDept = { 
				  ...this.selectedRow,
				  // 修复2: 将0/1转换为对应的单选值
				  mainDep: this.selectedRow.mainDep === 1 ? 1 : 0
				};
				this.editingDeptIndex = this.tableData.indexOf(this.selectedRow);
				this.deptDialogVisible = true;
			  },
			  
			  // 处理删除科室 - 修复3: 添加updateButtonStates方法
			  handleDeleteDept() {
				if (!this.selectedRow) return;
				
				const row = this.selectedRow;
				const index = this.tableData.indexOf(row);
				
				if (row.mainDep === 1) {
				  if (this.tableData.length === 1) {
					this.$message.error('必须极速电竞官网保留一个主要科室');
					return;
				  }
				  
				  this.$confirm('此科室为主要科室，删除后将自动设置其他科室为主要科室，确定删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				  }).then(() => {
					this.tableData.splice(index, 1);
					// 自动设置第一个科室为主要科室
					if (this.tableData.length > 0) {
					  this.tableData[0].mainDep = 1;
					}
					this.selectedRow = null;
					this.updateButtonStates(); // 修复3: 调用方法
					this.$message.success('删除成功');
				  });
				} else {
				  this.$confirm('确定要删除此科室吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				  }).then(() => {
					this.tableData.splice(index, 1);
					this.selectedRow = null;
					this.updateButtonStates(); // 修复3: 调用方法
					this.$message.success('删除成功');
				  });
				}
			  },
		      
		      
		      // 打开新增科室对话框
		      async openAddDeptDialog() {
		        this.deptDialogTitle = '新增隶属科室';
		        this.currentDept = {
		          deptName: '',
		          deptId: '',
		          mainDep: this.tableData.length === 0 ? '是' : '否' // 如果没有科室，默认设为主要
		        };
		        this.editingDeptIndex = -1;
		        
		        // 加载科室选项
		        await this.loadDeptOptions();
		        this.deptDialogVisible = true;
		      },
			  
		      // 加载科室选项
		      async loadDeptOptions() {
		        try {
		          const res = await findAttribute({
		            clinicId: this.employeeData.clinicId || this.clinicId
		          });
		          
		          if (res.code === 200) {
		            this.deptOptions = res.data.map(v => ({
		              id: v.id,
		              label: v.deptName,
		              value: v.deptName,
		              specialtyName: v.specialtyName,
		              remark: v.remark
		            }));
		          }
		        } catch (error) {
		          console.error('加载科室选项失败:', error);
		          this.$message.error('加载科室选项失败');
		        }
		      },
		      
		      // 检查科室是否已被选择
		      isDeptSelected(deptName) {
		        return this.tableData.some(item => 
		          item.deptName === deptName && 
		          this.tableData.indexOf(item) !== this.editingDeptIndex
		        );
		      },
		      
		      // 科室选择变化处理
		      handleDeptChange(selectedDeptName) {
		        const selectedDept = this.deptOptions.find(item => item.label === selectedDeptName);
		        if (selectedDept) {
		          this.currentDept.deptId = selectedDept.id;
		          this.currentDept.deptName = selectedDept.label;
		        }
		      },
		      
		     // 保存科室信息到 employeeData
		    saveDept() {
			  if (!this.currentDept.deptName) {
				this.$message.warning('请选择科室');
				return;
			  }
			  
			  // 转换 mainDep 值为 0/1
			  const deptData = {
				...this.currentDept,
				mainDep: this.currentDept.mainDep // 已经是0/1格式
			  };
			  
			  if (this.editingDeptIndex === -1) {
				// 新增模式
				const exists = this.tableData.some(item => 
				  item.dept极速电竞官网Name === deptData.deptName
				);
				if (exists) {
				  this.$message.error('该科室已存在');
				  return;
				}
				
				// 如果设置为主要科室，取消其他科室的主要状态
				if (deptData.mainDep === 1) {
				  this.tableData.forEach(item => {
					item.mainDep = 0;
				  });
				}
				
				this.tableData.push(deptData);
			  } else {
				// 编辑模式
				const oldData = this.tableData[this.editingDeptIndex];
				
				// 如果从非主要改为主要，取消其他科室的主要状态
				if (oldData.mainDep === 0 && dept极速电竞官网Data.mainDep === 1) {
				  this.tableData.forEach(item => {
					item.mainDep = 0;
				  });
				}
				
				this.tableData.splice(this.editingDeptIndex, 1, deptData);
			  }
			  
			  // 更新到 employeeData
			  this.employeeData.deptList = [...this.tableData];
			  this.deptDialogVisible = false;
			  this.$message.success('科室保存成功');
			  
			  // 清空选择
			  this.selectedRow = null;
			  this.updateButtonStates(); // 修复3: 调用方法
			},
		      
		      // 编辑科室
		      handleEdit() {
		        if (!this.selectedRow) {
		          this.$message.warning('请先选择要编辑的科室');
		          return;
		        }
		        
		        this.deptDialogTitle = '编辑隶属科室';
		        this.currentDept = { ...this.selectedRow };
		        this.editingDeptIndex = this.tableData.indexOf(this.selectedRow);
		        this.loadDeptOptions().then(() => {
		          this.deptDialogVisible = true;
		        });
		      },
		      
			  updateButtonStates() {
			        // 在新增/编辑模式下，禁用编辑和删除按钮（除非选择了行）
			        this.headerBtn.forEach(btn => {
			          if (btn.action !== 'add') {
			            btn.disabled = !this.selectedRow;
			          }
			        });
			      },
				  
		      // 删除科室
		      handleDelete() {
		        if (!this.selectedRow) {
		          this.$message.warning('请先选择要删除的科室');
		          return;
		        }
		        
		        const row = this.selectedRow;
		        const index = this.tableData.indexOf(row);
		        
		        if (row.mainDep === '是') {
		          if (this.tableData.length === 1) {
		            this.$message.error('必须保留一个主要科室');
		            return;
		          }
		          
		          this.$confirm('此科室为主要科室，删除后将自动设置其他科室为主要科室，确定删除吗？', '提示', {
		            confirmButtonText: '确定',
		            cancelButtonText: '取消',
		            type: 'warning'
		          }).then(() => {
		            this.tableData.splice(index, 1);
		            // 自动设置第一个科室为主要科室
		            if (this.tableData.length > 0) {
		              this.tableData[0].mainDep = '是';
		            }
		            this.selectedRow = null;
		            this.$message.success('删除成功');
		          });
		        } else {
		          this.$confirm('确定要删除此科室吗？', '提示', {
		            confirmButtonText: '确定',
		            cancelButtonText: '取消',
		            type: 'warning'
		          }).then(() => {
		            this.tableData.splice(index, 1);
		            this.selectedRow = null;
		            this.$message.success('删除成功');
		          });
		        }
		      },
		      
		      // 关闭科室对话框
		      handleDeptDialogClose(done) {
		        this.$confirm('确定关闭吗？未保存的内容将会丢失', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		          done();
		        }).catch(() => {});
		      },
			  
          handClick(i) {
            if (i === 0) {
              this.getKs(this.clinicId);
              this.ksDialog = true;
              this.nameTitle = '新建员工';
              this.addKsForm = {
                deptName: '',
                deptId: '',
                mainDep: this.tableData.length === 0 ? '是' : '否'
              };
              this.addBtn = true;
            }
          },
          
          
          // 处理行点击
		  handleRowClick(row) {
			this.selectedRow = row;
			this.updateButtonStates(); // 修复3: 调用方法
		  },
	  
          tableRowClassName({row}) {
            return row === this.selectedRow ? 'selected-row' : '';
          },
          
          sksName(v) {
            if(v.value == '重要科室') {
              this.addKsForm.mainDep = v.label;
              this.addBtn = false;
            } else {
              this.addKsForm.deptId = v.id;
              this.addKsForm.deptName = v.label;
              this.addBtn = false;
            }
          },
          
          // 新增/编辑保存科室
          addNewKs() {
            const isDeptExist = this.tableData.some(item => 
              item.deptName === this.addKsForm.deptName || 
              item.deptId === this.addKsForm.deptId
            );
            
            if (this.nameTitle !== '编辑' && isDeptExist) {
              this.$message.error(this.addKsForm.deptName + '：已存在于表格列表之中，请添加新的科室');
              return;
            }
            
            this.loading = true;
            
            if (this.nameTitle === '编辑') {
              setTimeout(() => {
                if (this.editingRow) {
                  Object.assign(this.editingRow, JSON.parse(JSON.stringify(this.addKsForm)));
                  this.$message.success('修改成功！');
                } else {
                  this.$message.error('编辑数据无效！');
                }
                
                this.loading = false;
                this.ksDialog = false;
                this.editingRow = null;
              }, 888);
            } else {
              const hasMainDept = this.tableData.some(item => item.mainDep === '是');
              
              if (this.addKsForm.mainDep === '是' && hasMainDept) {
                this.$message.error('主要科室只能有一个，请修改后再添加！');
                this.loading = false;
                return;
              }
              
              setTimeout(() => {
                if (this.addKsForm.mainDep === '是') {
                  this.tableData.forEach(item => {
                    item.mainDep = '否';
                  });
                }
                
                this.tableData.push(JSON.parse(JSON.stringify(this.addKsForm)));
                this.loading = false;
                this.ksDialog = false;
                this.$message.success('添加成功！');
              }, 1500);
            }
          },
          
          // 获取隶属机构
          async getInstitutionId() {
            try {
              let res = await docclinic();
              this.clincOptions = res.data.map(v => { return {label: v.name, ...v} });
            } catch (error) {
              console.error('获取机构信息失败:', error);
              this.$message.error('获取机构信息失败');
            }
          },
          
          // 获取科室
          async getKs(clinicId) {
            try {
              let res = await findAttribute({
                clinicId: clinicId
              });
              this.deptOption = res.data.map(v => {
                return { id: v.id, label: v.deptName, value: v.deptName, specialtyName: v.specialtyName, remark: v.remark }
              });
            } catch (error) {
              console.error('获取科室信息失败:', error);
              this.$message.error('获取科室信息失败');
            }
          },
          
          // 关闭模态框
          handleAddClose(done) {
            done();
            this.addKsForm = {
              deptName: '',
              deptId: '',
              mainDep: '是'
            };
          }
        }
      };
      </script>
      
<style lang="less" scoped>
  ::v-deep .el-form-item__label{
  	font-size: 12px;
  	font-weight: bold;
  }
  ::v-deep .el-dialog__header{
  	display: flex;
  	background: linear-gradient(135deg, #1a6be0 0%, #409EFF 100%);
  	padding: 12px 20px;
   }
  ::v-deep .el-dialog__title{
  	color: #fff;
  }
  /deep/ .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
	margin-bottom: 12px;
  }
  /deep/ .el-dialog__title{
	color: #fff;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close{
	color: #fff;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close:hover{
	background-color: brown;
  }
  /deep/ .el-dialog__body{
	padding: 0;
  }
  /deep/ .el-divider--horizontal{
	margin: 0;
  }
.watch-acc-dialog {
.el-dialog__header {
  background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
  padding: 12px 20px;
  
  .el-dialog__title {
	color: white;
	font-size: 16px;
	font-weight: 600;
  }
  
  .el-dialog__headerbtn {
	top: 12px;
	
	.el-dialog__close {
	  color: white;
	  
	  &:hover {
		color: #f0f0f0;
	  }
	}
  }
}

.el-dialog__body {
  padding: 0;
}
}

.dialog-content {
padding: 20px;
max-height: 70vh;
overflow-y: auto;

.section {
  margin-bottom: 20px;
  
  .section-header {
	margin-bottom: 10px;
	
	.section-title {
	  font-size: 14px;
	  font-weight: 600;
	  color: #303133;
	  padding-left: 8px;
	  border-left: 3px solid #67c23a;
	}
  }
  
  .table-section {
	background: #f8f9fa;
	border-radius: 4px;
	overflow: hidden;
	
	.table-title {
	  background: #e1f3d8;
	  padding: 8px 12px;
	  font-size: 13px;
	  font-weight: 600;
	  color: #67c23a;
	  border-bottom: 1px solid #dcdfe6;
	}
	
	.permissions-container {
	  padding: 15px;
	  background: white;
	  
	  .permission-row {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 10px;
		
		.el-checkbox {
		  margin-right: 20px;
		  min-width: 120px;
		}
	  }
	}
	
	.header {
	  display: flex;
	  justify-content: space-between;
	  align-items: center;
	  background: #e1f3d8;
	  padding: 4px 12px;
	  color: #67c23a;
	  .el-button {
		margin-left: 5px;
	  }
	}
	
	.info-table {
	  width: 100%;
	  border-collapse: collapse;
	  
	  td {
		padding: 8px 12px;
		border: 1px solid #dcdfe6;
		font-size: 12px;
		
		&.label {
		  background: #f5f7fa;
		  color: #606266;
		  font-weight: 500;
		  width: 80px;
		  text-align: right;
		}
		
		&.value {
		  background: white;
		  color: #303133;
		  width: 120px;
		}
	  }
	  
	  tr:hover td {
		background: #f0f9ff;
	  }
	}
	
	.file-table {
	  width: 100%;
	  border-collapse: collapse;
	  
	  th, td {
		padding: 10px 12px;
		border: 1px solid #dcdfe6;
		font-size: 12px;
		text-align: center;
	  }
	  
	  th {
		background: #e1f3d8;
		color: #67c23a;
		font-weight: 600;
	  }
	  
	  td {
		background: white;
		color: #303133;
	  }
	  
	  tr:hover {
		background: #f0f9ff;
	  }
	  
	  .no-data {
		color: #909399;
		font-style: italic;
		text-align: center;
	  }
	  
	  .action-buttons {
		display: flex;
		justify-content: center;
		gap: 8px;
		
		.el-button {
		  padding: 4px 8px;
		  min-height: auto;
		  
		  &:hover {
			color: #67c23a;
		  }
		}
	  }
	}
  }
}
}

.dialog-footer {
display: flex;
justify-content: flex-end;
gap: 10px;
padding: 10px 20px;
border-top: 1px solid #dcdfe6;
}

// 表格选中行样式
/deep/ .el-table .selected-row {
background-color: #f0f9eb;
}

// 滚动条样式
.dialog-content::-webkit-scrollbar {
width: 6px;
}

.dialog-content::-webkit-scrollbar-track {
background: #f1f1f1;
border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb {
background: #c0c4cc;
border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
background: #909399;
}

// 响应式设计
@media (max-width: 768px) {
.watch-acc-dialog {
  width: 95% !important;
  margin: 20px auto;
}

.dialog-content {
  padding: 10px;
  
  .info-table {
	font-size: 11px;
	
	td {
	  padding: 6px 8px;
	  
	  &.label, &.value {
		width: auto;
	  }
	}
  }
  
  .file-table {
	font-size: 11px;
	
	th, td {
	  padding: 6px 8px;
	}
  }
  
  .permissions-container {
	.permission-row {
	  flex-direction: column;
	  
	  .el-checkbox {
		margin-bottom: 8px;
	  }
	}
  }
}
}
.info-table {
.el-input, .el-select, .el-date-editor, .el-cascader {
  width: 100%;
}

td {
  padding: 4px 6px !important;
  
  .label {
	padding: 4px 6px !important;
  }
}
}
// 新增隶属科室模态框样式
.tabsMain {
/deep/ .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 12px;
}

/deep/ .el-form-item__label {
  display: flex;
  justify-content: right;
  font-size: 12px;
}

/deep/ .el-input--mini .el-input__inner {
  height: 26px;
  line-height: 26px;
}
}
</style>